import localforage from 'localforage'

export class SessionInformation {
  static _localForage = localforage.createInstance({
    name: 'sessionInformation',
  })

  static getItem = async (key) => {
    return await this._localForage.getItem(key)
  }

  static setItem = async (key, value) => {
    try {
      this._localForage.setItem(key, value)
      return true
    } catch (e) {
      console.log('There was a problem setting key to local storage', e)
      return false
    }
  }

  static deleteItem = async (key) => {
    try {
      this._localForage.deleteItem(key)
      return true
    } catch (e) {
      console.log('There was a problem deleting key to local storage', e)
      return false
    }
  }

  static clearAll = async () => {
    await this._localForage.clear()
  }
}
